<template>
  <div class="is-marginless is-paddingless section">
    <div class="entete">
      <div class="columns">
        <div class="column">
          <div class="title is-size-3">
            {{ getTitle }}
          </div>
          <app-breadcrumb :breadcrumb="breadcrumb"/>
        </div>
      </div>
      <div class="tab is-marginless">
        <ul>
          <li :class="{'is-active': activeTab === 'tabListeLignesCommande'}"
              @click="updateActiveTab('tabListeLignesCommande')">
            {{ $t('lignesCommandeManager.onglet.lignesCommande') }}
          </li>
          <li :class="{'is-active': activeTab === 'listeLignesCmdARenouveler'}"
              @click="updateActiveTab('listeLignesCmdARenouveler')">
            {{ $t('lignesCommandeManager.onglet.aRenouveler') }}
          </li>
        </ul>
      </div>

    </div>
    <component :is="activeTab"
      :produitId="$route.params.produitId"
      :type-location-or-divers="$route.params.typeLocationOrDivers">
    </component>
  </div>
</template>

<script>

import AppBreadcrumb from '@/components/general/breadcrumb';
import inProgress from '@/services/general/inProgress';
import listeLignesCmdARenouveler from '@/components/bodac/lignesCommande/l_lignesCommandeARenouveler';
import tabListeLignesCommande from '@/components/bodac/lignesCommande/tabListeLignesCommande';

export default {
  data() {
    return {
      activeTab: 'tabListeLignesCommande',
    };
  },
  components: {
    AppBreadcrumb,
    listeLignesCmdARenouveler,
    tabListeLignesCommande,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.getTitle, route: { name: '' }, isActive: true },
      ];
    },
    getTitle() {
      switch (this.activeTab) {
        case 'listeLignesCmd':
          return this.$i18n.t('lignesCommandeManager.titleLigneCmd');
        default:
          return this.$i18n.t('lignesCommandeManager.titleARenouveler');
      }
    },
  },
  methods: {
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    updateActiveTab(activeTab) {
      this.activeTab = activeTab;
      switch (activeTab) {
        case 'listeLignesCmd':
          this.setInformationPage(this.$t('pageGescom.lignesCommandes.listeLigneCmd'));
          break;
        default:
          this.setInformationPage(this.$t('pageGescom.lignesCommandes.listeARenouveler'));
          break;
      }
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageGescom.lignesCommandes.listeLigneCmd'));
  },
};
</script>
